import { fetchWithAuth, getCSRFToken } from '../auth';

const API_HOST = process.env.REACT_APP_ICC_TOOL_API_HOST;

export async function listVideoContent(search = '', page = 1, pageSize = 20) {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    params.set('page', page);
    params.set('page_size', pageSize);
    const url = `${API_HOST}video-content/?${params.toString()}`;
    const resp = await fetchWithAuth(url, { credentials: 'include' });
    if (!resp.ok) throw new Error('Failed to fetch video content');
    return resp.json();
}

// Registers the uploaded blob in the backend (JSON, not multipart)
export async function registerVideoContent(payload) {
    const resp = await fetchWithAuth(`${API_HOST}video-content/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken()
        },
        credentials: 'include',
        body: JSON.stringify(payload)
    });
    if (!resp.ok) throw new Error('Failed to register video content');
    return resp.json();
}

export async function updateVideoContent(id, payload) {
    const resp = await fetchWithAuth(`${API_HOST}video-content/${id}/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCSRFToken() },
        credentials: 'include',
        body: JSON.stringify(payload)
    });
    if (!resp.ok) throw new Error('Failed to update video content');
    return resp.json();
}

export async function deleteVideoContent(id) {
    const resp = await fetchWithAuth(`${API_HOST}video-content/${id}/`, {
        method: 'DELETE',
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    });
    if (!resp.ok) throw new Error('Failed to delete video content');
}
